import React, { useContext } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { StoreSearchContext } from '../StoreSearch.context';

export const SuggestedAddresses = ({ stores }) => {
  const { setSearchCoordinates } = useContext(StoreSearchContext);

  return (
    <div className="sui-grid sui-p-2">
      <Typography weight="bold">Did You Mean:</Typography>
      <div className="sui-flex sui-flex-col sui-items-start">
        {stores.map((store) => (
          <button
            key={store.name}
            onClick={() => setSearchCoordinates(store.coordinates)}
            type="button"
          >
            <Typography decoration="underline">
              {store.name}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
};

SuggestedAddresses.propTypes = {
  stores: arrayOf({
    store: shape({
      coordinates: shape({
        lat: string,
        lng: string
      }),
      name: string,
    })
  }).isRequired
};

SuggestedAddresses.displayName = 'SuggestedAddresses';
